"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const Words_1 = __importDefault(require("../../assets/icons/Words"));
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalRange_1 = __importDefault(require("../modal/ModalRange"));
const Lock_1 = __importDefault(require("../../assets/icons/Lock"));
const Status = (props) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [status, setStatus] = (0, react_1.useState)(props?.statusPost);
    (0, react_1.useEffect)(() => {
        setStatus(props?.statusPost);
    }, [props?.statusPost]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        status == 0 && (react_1.default.createElement(react_native_1.TouchableOpacity, { disabled: !props?.edit, style: {
                height: (0, scale_1.scale)(23),
                width: (0, scale_1.scale)(85),
                borderWidth: (0, scale_1.scale)(1),
                borderColor: "#287BCF",
                borderRadius: (0, scale_1.scale)(99),
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
            }, onPress: (() => { setVisible(true); }) },
            react_1.default.createElement(Words_1.default, null),
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(10),
                    lineHeight: (0, scale_1.moderateScale)(15),
                    color: "#287BCF",
                    marginLeft: (0, scale_1.scale)(5),
                } }, "\u5168\u54E1\u306B\u516C\u958B"))),
        status == 1 && (react_1.default.createElement(react_native_1.TouchableOpacity, { disabled: !props?.edit, style: {
                height: (0, scale_1.scale)(23),
                width: (0, scale_1.scale)(105),
                borderWidth: (0, scale_1.scale)(1),
                borderColor: "#575B72",
                borderRadius: (0, scale_1.scale)(99),
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
            }, onPress: () => setVisible(true) },
            react_1.default.createElement(Lock_1.default, null),
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(10),
                    lineHeight: (0, scale_1.moderateScale)(15),
                    color: "#575B72",
                    marginLeft: (0, scale_1.scale)(5),
                } }, "\u30D5\u30A9\u30ED\u30EF\u30FC\u9650\u5B9A"))),
        react_1.default.createElement(ModalRange_1.default, { visible: visible, onClose: () => setVisible(false), value: status, onSelect: (index) => {
                setStatus(index), setVisible(false), props?.onChange(index);
            } })));
};
exports.Status = Status;
